import React from "react";
import Navbars from "./Navbar";
import Socialiocn from "./SocialIcons";

const GetInTouch = () => {
  return (
    <>
      <Navbars />
      <section className="max-w-4xl mx-auto p-6 font-sans bg-white rounded-lg shadow-lg text-black">
        {/* Heading */}
        <h2 className="text-2xl sm:text-2xl lg:text-2xl font-semibold text-center font-poppins mb-6">
          Get in Touch
        </h2>
        <p className="text-lg text-center mb-6 font-poppins">
          Let’s Create Something Remarkable Together
        </p>
        <p className="text-lg text-center mb-6 font-poppins">
          At StoneAge Films, we’re passionate about turning ideas into stunning
          visual stories. Whether you’re planning a bold new campaign, crafting
          dynamic digital content, or embarking on a full-scale production,
          we’re ready to bring your vision to life.
        </p>

        {/* Contact Info */}
        <p className="text-sm text-center mb-6 font-poppins">
          <strong>Contact Us</strong>
          <br />
          Email:{" "}
          <a
            href="mailto:amit@stoneagefilms.in"
            className="text-blue-600 font-poppins hover:underline"
          >
            amit@stoneagefilms.in
          </a>
          <br />
          Or, fill out our contact form to share your ideas and requirements
          with us.
          <br />
          We’re excited to collaborate and make your story unforgettable. Let’s
          start the conversation today!
        </p>

        {/* Contact Form */}
        <form
          className="space-y-4 font-poppins"
          action="https://formsubmit.co/amit@stoneagefilms.in"
          method="POST"
        >
          <input type="hidden" name="_captcha" value="false" />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              required
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              required
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <textarea
            name="message"
            placeholder="Your Message"
            required
            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          ></textarea>
          <button
            type="submit"
            className="w-full py-3 font-poppins bg-[#0A0A0A] text-white font-semibold rounded-lg hover:bg-blue-600 transition duration-300"
          >
            Submit Form
          </button>
        </form>

        {/* Location */}
        <div className="mt-8">
          <h3 className="text-xl font-semibold mb-4 font-poppins">
            Our Location
          </h3>
          <div className="relative w-full h-64">
            <iframe
              title="Mumbai Map"
              width="100%"
              height="100%"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d377731.6576397434!2d72.66988459405296!3d19.076090132343348!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c9fe0f17e9f7%3A0x408d1c9cfb8f3036!2sMumbai%2C%20Maharashtra%2C%20India!5e0!3m2!1sen!2sin!4v1694215028240!5m2!1sen!2sin"
              loading="lazy"
              style={{ border: 0 }}
            ></iframe>
          </div>
        </div>

        {/* Social Links */}
        <div className="py-6 flex justify-center md:justify-start space-x-6 text-2xl mt-6">
          {/* Email */}
          <a
            href="mailto:amit@stoneagefilms.in"
            className="hover:text-gray-500 transition-colors duration-300"
            aria-label="Email"
          >
            {/* Email Icon SVG */}
          </a>
          {/* LinkedIn, Vimeo, Facebook, Instagram icons here */}
        </div>
      </section>
      <Socialiocn />
    </>
  );
};

export default GetInTouch;
